






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CompanyDocument, User } from '../store/models';
import user from '@/store/modules/user';
import { enableSharing } from '@/config';

@Component({ components: {} })
export default class DocumentSharing extends Vue {
  @Prop() readonly doc!: CompanyDocument;

  get documentType() {
    switch (this.doc.Data.Type) {
      case 'deck-template':
        return 'mall';
      default:
        return 'presentation';
    }
  }

  get enabled() {
    return;
  }

  get sharedWith(): User[] {
    return this.doc.SharedWith;
  }

  get sharedBy(): User {
    return this.doc.SharedBy ? this.doc.SharedBy : ({} as User);
  }

  get sharedByOther(): boolean {
    const me = user.user ? user.user.UserId : '';
    return this.sharedBy.UserId !== me;
  }

  get userIdEx() {
    return user.activeExternalUser;
  }

  get enableSharing() {
    return enableSharing; // && !(this.doc && this.doc.Data && this.doc.Data.Type === 'deck-template');
  }
}
